export const formatPrice = (value) =>
  value === undefined || value === '' ? '0.00' : parseFloat(value).toFixed(2);
export default {
  formatPrice,
};
